import type { Timestamp } from "@firebase/firestore-types";
import type { Account } from "../account/models.js";

export const accountInvitationsFullPath = "accountInvitations";
export const accountInvitationFullPath = (invitationId: string): string =>
  `${accountInvitationsFullPath}/${invitationId}`;

/**
 * A supervisor org asks to supervise a self-onboarded Treezor account. The supervisor org cannot read the account
 * until the account holder signs the tripartite contract: `settings` are applied to the account at
 * that point, then the invitation is deleted.
 */
export type AccountInvitation = {
  supervisorOrgId: string;
  supervisorOrgName: string;
  accountId: string;
  companyName: string;
  siren: string;
  status: "pending" | "refused";
  contractTemplateId: string;
  envelopeId: string;
  settings: {
    assignedUsers: string[];
    transferAmountThreshold: number | null;
    notifications: NonNullable<Account["notifications"]>;
  };
  invitedBy: string;
  createdAt: Timestamp;
  refusedAt?: Timestamp;
};
